import {CurrentPageDataService} from 'shared/page';
import register from '@kpsys/angularjs-register';
import {PageController} from './page.controller';

export default register('portaro.shared.page')
    .service(CurrentPageDataService.serviceName, CurrentPageDataService)
    .controller(PageController.controllerName, PageController)
    .name();